import imageCompression from "browser-image-compression";
import { config } from "@/config";

interface CompressionOptions {
  maxSizeMB?: number;
  maxWidthOrHeight?: number;
  useWebWorker?: boolean;
  initialQuality?: number;
}

export function isImageFile(file: File): boolean {
  return config.imageCompression.imageTypes.includes(file.type as string);
}

export async function compressImage(
  file: File,
  options: CompressionOptions = {},
): Promise<File> {
  const { maxSizeMB, maxWidthOrHeight, useWebWorker, initialQuality } = options;

  try {
    const compressedBlob = await imageCompression(file, {
      maxSizeMB,
      maxWidthOrHeight,
      useWebWorker,
      initialQuality,
      fileType: file.type,
    });

    return new File([compressedBlob], file.name, {
      type: file.type,
      lastModified: Date.now(),
    });
  } catch (error) {
    console.error(`Erro ao comprimir ${file.name}:`, error);
    return file;
  }
}

export async function compressFiles(
  files: File[],
  options: CompressionOptions = config.imageCompression,
): Promise<File[]> {
  const compressionPromises = files.map(async (file) => {
    if (!isImageFile(file)) {
      return file;
    }
    const compressedFile = await compressImage(file, options);

    return compressedFile;
  });

  return Promise.all(compressionPromises);
}
